// JavaScript Functions and Initiations
var jquery = require('jquery');
window.$ = window.jQuery = jquery;
import WebFont from 'webfontloader'
import GoogleMapsLoader from 'google-maps'
import TinyDatePicker from 'tiny-date-picker'
import magnificPopup from 'magnific-popup'

// Load Custom Google Font
WebFont.load({
  google: {
    families: ['Caveat:400,700', "Karma:300,400,700", 'Montserrat:400,700']
  }
});

// Date Picker
TinyDatePicker(document.querySelector('.date'), {mode: 'dp-below'});

// Lightbox
$('.gallery').magnificPopup({
  delegate: 'a',
  type: 'image',
  tLoading: 'Loading image #%curr%...',
  mainClass: 'mfp-img-mobile',
  gallery: {
    enabled: true,
    navigateByImgClick: true,
    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
  },
  image: {
    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
    titleSrc: function(item) {
      return item.el.attr('title');
    }
  }
});

// Scroll to Anchors
$('[href^=\\#]').on('click', function() {
  var $this = $(this);
  var $linkID = $this.attr('href');
  $('html,body').animate({scrollTop: $($linkID).offset().top}, 500);
  return false;
});

// Google Map
GoogleMapsLoader.load(function(google) {
  var map = document.getElementById('google-map');

  var map_options = {
    center: new google.maps.LatLng(-8.6922877,115.1625646),
    scrollwheel: false,
    zoom: 16,
    mapTypeId: google.maps.MapTypeId.ROADMAP
  }
  var map = new google.maps.Map(map, map_options)

  // Map Marker
  var myLatlng = new google.maps.LatLng(-8.6922877,115.1625646);
  var marker = new google.maps.Marker({
    position: myLatlng,
    map: map,
    icon: '../img/pin.svg'
  });
  map.panBy(-300, 0);
})

// Booking Form
$('.booking-form').on('submit', function(e) {
  e.preventDefault();
  var $this = $(this);
  var $url = $this.attr('action');

  // Error Messages
  var $bookingErrorMessage = 'Whoops. There was an issue sending your booking - please fill out the form and try again.'

  // Success Messages
  var $bookingSuccessHeading = 'Your booking was successfully sent';
  var $bookingSuccessMessage = 'One of our representatives will get in touch with you to confirm your booking.';

  $.ajax({
    url: $url,
    method: 'POST',
    data: $(this).serialize(),
    dataType: 'json',
    beforeSend: function() {
      $this.prop('disabled', true);
      $this.find('.submit-button').attr('value','Sending...')
      $this.find('.booking-error').remove();
    },
    success: function(data) {
      $this.prop('disabled', false);
      $this.find('.submit-button').attr('value', 'Submit');
      $this.html('<div class="booking-success text-center"><h2 class="fs-4 heading-secondary">' + $bookingSuccessHeading + '</h2><p>' + $bookingSuccessMessage + '</p></div>');
    },
    error: function(err) {
      $this.prop('disabled', false);
      $this.find('.submit-button').attr('value', 'Submit');
      $this.find('legend').after('<div class="booking-error text-center">' + $bookingErrorMessage + '</div>');
      $('html,body').stop(true, true).animate({scrollTop: $('#booking').offset().top}, 500);
    }
  });
});